import type { ReceiptTemplate } from '../schema';

export const walgreensTemplate: ReceiptTemplate = {
  id: 'walgreens',
  name: 'Walgreens Receipt',
  brand: 'WALGREENS',
  description: 'Pharmacy and retail store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'wag-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/walgreens.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #0127',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wag-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'TRANS: 8472  REG: 03  01/04/26 15:12\nCASHIER: MIKE W',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'wag-balance',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Balance Rewards #********4144',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'wag-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'wag-item-1', name: 'TYLENOL 500MG 50CT', quantity: '1', price: '9.99'},
          { id: 'wag-item-2', name: 'WAG COTTON BALLS', quantity: '1', price: '3.49'},
          { id: 'wag-item-3', name: 'COLGATE TOOTHPASTE', quantity: '1', price: '4.99'},
          { id: 'wag-item-4', name: 'DIET COKE 20OZ', quantity: '2', price: '2.29'},
          { id: 'wag-item-5', name: 'LAYS CHIPS', quantity: '1', price: '4.29'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'wag-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'wag-subtotal', label: 'SUBTOTAL', value: '27.34', isBold: false, isLarge: false },
          { id: 'wag-savings', label: 'BR SAVINGS', value: '-2.50', isBold: false, isLarge: false },
          { id: 'wag-tax', label: 'TAX', value: '2.20', isBold: false, isLarge: false },
          { id: 'wag-total', label: 'TOTAL', value: '27.04', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'wag-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'wag-card', label: 'MASTERCARD', value: '************4144' },
          { id: 'wag-auth', label: 'AUTH', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'wag-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '** BALANCE REWARDS **\nPOINTS EARNED: 2,704\nTOTAL POINTS: 15,847',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'wag-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '01278472010426',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wag-survey',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'WALGREENSLISTENS.COM\nTELL US ABOUT YOUR VISIT',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

